import { keycloak } from "../../../../lib/keycloak";
import { M024CopyPrevDTO, M024CreationOptionsDTO, M024ResponseOptionsDTO, M024UpdateOptionsDTO } from "./dto";
import { M024Service } from "./service";
import axios from "axios";

export class M024ServiceImpl implements M024Service {

    public CreateM024(data: M024CreationOptionsDTO): Promise<M024ResponseOptionsDTO> {
        return axios.post("/api/m024",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public M024CopyPrev(data: M024CopyPrevDTO): Promise<void> {
        return axios.post("/api/m024",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public Updatem024Options(data: M024UpdateOptionsDTO, id: string): Promise<void> {
        return axios.put("/api/m024/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteM024(id: string): Promise<void> {
        return axios.delete("/api/m024/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}